import { Box, Modal } from "@mui/material";
import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";

const TablesDisplayModal = ({
  tables,
  onTableSelect,
  selectedTable,
  onOccupiedTableClick, // Add this prop
  showModal,
  setShowModal,
}) => {
  const { t } = useTranslation();

  // Effect to handle when selectedTable becomes null (e.g., when user clears selection)
  useEffect(() => {
    if (!selectedTable && tables && tables.length > 0) {
      const defaultTable = tables.find((table) => table.default === true);
      if (defaultTable && onTableSelect) {
        onTableSelect(defaultTable);
      }
    }
  }, [selectedTable, tables, onTableSelect]);

  const getStatusColor = (status) => {
    switch (status) {
      case "available":
        return "#4CAF50";
      case "occupied":
        return "#f44336";
      case "reserved":
        return "#ff9800";
      case "price":
        return "#95abf3ff";
      default:
        return "#757575";
    }
  };

  const handleTableClick = (table) => {
    // If table is occupied and we have the onOccupiedTableClick function,
    // check if it has session data to load
    if (table.status === "occupied" && onOccupiedTableClick) {
      // Prepare the table data to pass to parent
      onOccupiedTableClick(table);
    } else {
      // For available tables or when no session data exists
      onTableSelect && onTableSelect(table);
    }
  };

  const handleClose = () => {
    // Only close if not disabled
    setShowModal(false);
  };

  // Prevent clicking outside (backdrop) from closing
  const handleBackdropClick = (event) => {
    event.stopPropagation();
  };
  if (!showModal) return null;
  return (
    <Modal
      open={showModal}
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <Box
        sx={{
          width: "90%",
          maxHeight: "90vh",
          bgcolor: "background.paper",
          borderRadius: 2,
          boxShadow: 24,
          p: 2,
          display: "flex",
          flexDirection: "column",
          overflow: "hidden",
        }}
      >
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center", // Keeps title in the middle
            position: "relative", // Needed for absolute positioning of the button
            mb: 2,
            pb: 1,
            borderBottom: "1px solid #e0e0e0",
          }}
        >
          <h2 style={{ margin: 0 }}>{t("Tables")}</h2>

          <button
            className="btn btn-primary p-0"
            onClick={() => setShowModal(false)}
            style={{
              position: "absolute", // Takes button out of flow
              right: "0px", // Pins it to the right
              backgroundColor: "red",
              width: "24px",
              height: "24px",
              display: "flex", // Ensures icon inside button is centered
              alignItems: "center",
              justifyContent: "center",
              border: "none",
              borderRadius: "4px",
            }}
          >
            <i className="fas fa-times"></i>
          </button>
        </Box>

        <Box sx={{ flex: 1, overflowY: "auto" , overflow:'hidden'}}>
          {" "}
          {/* Add overflowY: "auto" here */}
          <div className="content-wrapper pt-0" style={{ margin: 0 }}>
            <div className="container-full">
              <div className="tables-display-vertical-grid">
                {tables.length > 0 ? (
                  <div className="tables-grid-vertical">
                    {tables.map((table) => (
                      <div
                        key={table._id}
                        className={`table-item-vertical ${
                          table.status === "reserved" ||
                          (table.status === "occupied" &&
                            !table.active_sessions[0]?.confirmed)
                            ? "reserved-vertical"
                            : table.status === "occupied"
                              ? "occupied-vertical"
                              : "available-vertical"
                        }`}
                        onClick={() => {
                          // console.log(table)
                          handleTableClick(table);
                          handleClose();
                        }}
                      >
                        <div className="table-info-vertical">
                          <img
                            src={
                              table.status === "occupied"
                                ? "images/full.png"
                                : "images/available.png"
                            }
                            alt={table.status}
                            className="table-icon-vertical"
                          />
                          <span className="table-number-vertical">
                            {table.default === true
                              ? "Comptoir"
                              : "Table " + table.table_number}
                          </span>
                        </div>
                        {table.status === "occupied" &&
                        !table.active_sessions[0]?.confirmed ? (
                          <div
                            className="table-status-vertical"
                            style={{
                              backgroundColor: getStatusColor("reserved"),
                            }}
                          >
                            En attente
                          </div>
                        ) : table.status === "occupied" &&
                          table.active_sessions[0]?.confirmed ? (
                          <div
                            className="table-status-vertical"
                            style={{
                              backgroundColor: getStatusColor("price"),
                            }}
                          >
                            {`Total : ${table.active_sessions[0]?.total_amount?.toFixed(3)}`}
                          </div>
                        ) : (
                          <div
                            className="table-status-vertical"
                            style={{
                              backgroundColor: getStatusColor(table.status),
                            }}
                          >
                            Réserver
                          </div>
                        )}
                      </div>
                    ))}
                  </div>
                ) : (
                  <div className="no-tables-vertical">
                    <div className="no-tables-icon-vertical">🍽️</div>
                    <p>Aucune table disponible</p>
                  </div>
                )}
              </div>
            </div>
          </div>
        </Box>
      </Box>
    </Modal>
  );
};

export default TablesDisplayModal;
